__turbopack_context__.v({
  "botMessage": "messege-item-module-scss-module__XVsz1G__botMessage",
  "message": "messege-item-module-scss-module__XVsz1G__message",
  "messageContent": "messege-item-module-scss-module__XVsz1G__messageContent",
  "timestamp": "messege-item-module-scss-module__XVsz1G__timestamp",
  "userMessage": "messege-item-module-scss-module__XVsz1G__userMessage",
});
